import { z } from "zod";

const optionalId = z
  .union([z.string().min(1).max(100), z.literal(""), z.null()])
  .optional()
  .transform((value) => (value ? value : null));

export const requestCreateSchema = z.object({
  requestType: z.enum([
    "asset_claim",
    "asset_borrow",
    "accessory_apply",
    "consumable_issue",
    "software_seat",
  ]),
  materialId: z.string().min(1).max(100),
  quantity: z.coerce.number().int().min(1).max(1000),
  purpose: z.string().trim().max(500).optional().nullable(),
  neededBy: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, "日期格式应为 yyyy-mm-dd")
    .optional()
    .nullable(),
  borrowDays: z.coerce.number().int().min(1).max(365).optional().nullable(),
  months: z.coerce.number().int().min(1).max(36).default(12),
  companyId: optionalId,
  departmentId: optionalId,
  costCenterId: optionalId,
});

export const approvalDecisionSchema = z.object({
  decision: z.enum(["approve", "reject"]),
  comment: z.string().trim().max(500).optional().nullable(),
});

export const handoverCreateSchema = z.object({
  requestId: z.string().min(1).max(100),
  assetId: optionalId,
  accessoryId: optionalId,
  licenseId: optionalId,
  dueAt: z.string().datetime({ offset: true }).optional().nullable(),
  confirmationMethod: z.enum(["system", "signature", "one_time_link"]).default("system"),
});

export const handoverDecisionSchema = z.object({
  decision: z.enum(["confirm", "reject"]),
  confirmationText: z.string().trim().max(1000).optional().nullable(),
  rejectedReason: z.string().trim().max(500).optional().nullable(),
  signatureData: z.string().max(200_000).optional().nullable(),
});
